import girl from '../img/reviews/girl.png';
import boy from '../img/reviews/boy.png';

const Reviews = () => {
  return (
    <section id="reviews" className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="text-center mb-20">
          <h1
            className="
              text-5xl
              font-medium
              title-font
              mb-4
            "
          >
            Customer's Reviews
          </h1>
          <div className="flex mt-6 justify-center">
            <div
              className="
                w-28
                h-2
                rounded-full
                bg-purple-500
                inline-flex
              "
            ></div>
          </div>
        </div>
        <div className="flex flex-wrap -m-4">
          <div className="p-4 md:w-1/2 w-full">
            <div className="h-full bg-gray-100 p-8 rounded">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                className="block w-5 h-5 text-gray-400 mb-4"
                viewBox="0 0 975.036 975.036"
              >
                <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"></path>
              </svg>
              <p className="leading-relaxed mb-6 italic">
                It's the best chocolate cake in the world.. it went perfectly
                with the rainy weather.. looking forward to order more & I
                highly recommend Slice of Dreams.
              </p>
              <a href="/" className="inline-flex items-center">
                <img
                  alt="girl"
                  src={girl}
                  className="
                    w-12
                    h-12
                    rounded-full
                    flex-shrink-0
                    object-cover object-center
                  "
                />
                <span className="flex-grow flex flex-col pl-4">
                  <span
                    className="
                      title-font
                      font-medium
                      text-gray-600
                    "
                  >
                    <h3 className="text-xl">Zannatul Islam Shorna</h3>
                  </span>
                  <span className="text-gray-500 text-sm">Customer</span>
                </span>
              </a>
            </div>
          </div>
          <div className="p-4 md:w-1/2 w-full">
            <div className="h-full bg-gray-100 p-8 rounded">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                className="block w-5 h-5 text-gray-400 mb-4"
                viewBox="0 0 975.036 975.036"
              >
                <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"></path>
              </svg>
              <p className="leading-relaxed mb-6 italic">
                I loved the test of the cake, the packaging was cool. Good time
                delivery and great services. Delicious cake I have ever
                tasted...Best moist cake in this town.
              </p>
              <a href="/" className="inline-flex items-center">
                <img
                  alt="boy"
                  src={boy}
                  className="
                    w-12
                    h-12
                    rounded-full
                    flex-shrink-0
                    object-cover object-center
                  "
                />
                <span className="flex-grow flex flex-col pl-4">
                  <span
                    className="
                      title-font
                      font-medium
                      text-gray-600
                    "
                  >
                    <h3 className="text-xl">Abdullah Arian</h3>
                  </span>
                  <span className="text-gray-500 text-sm">Customer</span>
                </span>
              </a>
            </div>
          </div>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/media/set/?vanity=Sliceofdream&set=a.155348179664587"
            className="flex mx-auto mt-16 text-white bg-purple-500 border-0 py-2 px-8 focus:outline-none hover:bg-purple-600 rounded text-lg"
          >
            See More
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
